import { Chip, Paper, Stack, Typography } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ServiceOrderCard = ({
  name,
  groupName,
  pageName,
  applicationFee,
  currency,
  isForCitizen,
  ...rest
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const onClick = () => {
    navigate(pageName, {
      state: { groupName, name, applicationFee, currency, isForCitizen, ...rest },
    });
  };
    
  return (
    <Paper sx={{ cursor: "pointer" }} onClick={onClick} elevation={2}>
      <Stack
        sx={{ p: 2.5 }}
        gap={1.25}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1.5}>
          <Stack direction="row" alignItems="center" sx={{ minWidth: 0 }}>
            <SettingsIcon color="primary" />
            <Typography sx={{ fontWeight: "bold", marginRight: 1 }}>
              {name}
            </Typography>
          </Stack>
          <Typography
            sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
            color="primary"
          >{`${applicationFee} ${currency?.[0]?.code}`}</Typography>
        </Stack>

        {typeof isForCitizen === "boolean" && (
          <Stack direction="row" justifyContent="flex-start">
            <Chip
              label={isForCitizen ? t("serviceGuide_availableOnline") : t("serviceGuide_availableAtMunicipality")}
              size="small"
              color={isForCitizen ? "success" : "default"}
              variant={isForCitizen ? "filled" : "outlined"}
              sx={{ fontWeight: 700 }}
            />
          </Stack>
        )}
      </Stack>
    </Paper>
  );
};
export default ServiceOrderCard;
